import {connect} from 'react-redux';

import {QCManagerState} from '../QCManager/QCManagerTypes';
import QCJobsContainer from './QCJobsContainer';
import {
    setQCWorkQueueAction,
    resetQCWorkQueueAction,
    getQCWorkQueueSummaryAction,
} from '../QCManager/Redux/QCManagerActions';
import {createMultipleJiraIssueAction} from './QCJobsDialogs/JiraIssueCreate/Redux/JiraIssueCreateActions';

export type QCState = {qcManager: QCManagerState};

export const mapState = (state: QCState): QCState => {
    const {qcManager} = state;

    return {
        qcManager,
    };
};

export const mapDispatch = {
    setQCJobs: setQCWorkQueueAction,
    resetQCJobs: resetQCWorkQueueAction,
    getQCJobsSummary: getQCWorkQueueSummaryAction,
    createJiraMultipleIssue: createMultipleJiraIssueAction,
};

export default connect(mapState, mapDispatch)(QCJobsContainer);
